import { SecondaryButton } from '@chegg-ui/button'
import { colors, font, spacing } from '@chegg-ui/theme'
import styled from 'styled-components'

export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${spacing.px8};
  padding-top: ${spacing.px12};
`

export const UpdateButton = styled(SecondaryButton).attrs({
  variant: 'default',
  size: 'small',
})`
  && {
    background-color: ${({ disabled }) => (disabled ? colors.grey100 : '#1DA275')};
    color: ${({ disabled }) => (disabled ? colors.grey500 : colors.white)};
    font-size: ${font.size.px14};
    font-weight: ${font.weight.bold};
  }

  ${({ disabled }) =>
    disabled
      ? ''
      : `
    &&:hover,
    &&:focus {
      background-color: ${colors.mint700};
    }
  `};
`

export const GrammarSuggestionCardText = styled.span`
  color: ${colors.grey700};
  font-weight: ${font.weight.normal};
  overflow-wrap: anywhere;
`

export const OriginalText = styled.span`
  text-decoration: line-through;
`

export const ReplacementText = styled.span`
  color: ${colors.grey900};
  font-weight: ${font.weight.bold};
`
